export const AdminRolesEnum = {
  ADMIN: 'admin',
  DEVELOPER: 'developer',
  SUPPORT: 'support',
  EDITOR: 'editor',
};
